import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import getOTPFromApi from './getOTP';
import queryKeys from '../reactQuery/queryKeys';

const useGetOtp = () => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);

  const getOtp = async (bookingId: string) => {
    setIsLoading(true);
    await queryClient.fetchQuery({
      queryKey: queryKeys.otp({
        bookingId,
      }),
      queryFn: ({ signal }) => getOTPFromApi({ bookingId }, signal),
    });
    setIsLoading(false);
  };

  return {
    isLoading,
    getOtp,
  };
};

export default useGetOtp;
